import * as React from "react";
import Box from "@mui/material/Box";
import Drawer from "@mui/material/Drawer";
import Toolbar from "@mui/material/Toolbar";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import { AnalyticsOutlined, Ballot, Person , Assessment } from "@mui/icons-material";
import WebIcon from '@mui/icons-material/Web';
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import styles from "../CSS/HeaderSideNav.module.css";
import Analytics from "../../pages/analytics/Analytics";

const drawerWidth = 240;
const bgcolor = "transparent";
const color = "#000";

const SideNav = () => {
	const { access } = useSelector((state) => state.authReducer);

	const menuItems = (access) => {
		const menu = [
			// {
			// 	path: "/",
			// 	icon: <DashboardIcon />,
			// 	linkText: "My Dashboard",
			// },
		];

		if (access?.Admins === true) {
			menu.push({
				path: "/admins",
				icon: <Person />,
				linkText: "Admin Management",
			},
				// {
				// 	path: "/analytics",
				// 	icon: <AnalyticsOutlined />,
				// 	linkText: "Analytics",
				// }
			);
		}

		if (access?.Poll === true) {
			menu.push({
				path: "/polls",
				icon: <Ballot />,
				linkText: "Polls",
			});
		}
if (access?.Poll === true) {
			menu.push({
				path: "/analytics-report",
				icon: <Assessment />,
				linkText: "Analytics-Report",
			});
		}
		// if (access?.Seo === true) {
		// 	menu.push({
		// 		path: "/seo",
		// 		icon: <WebIcon />,
		// 		linkText: "SEO",
		// 	});
		// }

		// menu.push({
		// 	path: "/seo",
		// 	icon: <WebIcon />,
		// 	linkText: "SEO",
		// });
		
		return menu;
	};

	const navigate = useNavigate();
	const handleClick = (path) => {
		navigate(path);
	};
	const drawer = (
		<Box sx={ { overflow: "auto" } } className={ styles.SideNav }>
			<List>
				{ menuItems(access)?.map((item, index) => (
					<ListItem key={ index } disablePadding>
						<ListItemButton onClick={ () => handleClick(item.path) }>
							<ListItemIcon sx={ { color: color } }>{ item.icon }</ListItemIcon>
							<ListItemText primary={ item.linkText } />
						</ListItemButton>
					</ListItem>
				)) }
			</List>
		</Box>
	);
	return (
		<Box
			component='nav'
			sx={ { width: { sm: drawerWidth }, flexShrink: { sm: 0 }, border: "none" } }
			aria-label='mailbox folders'
		>
			<Drawer
				variant='permanent'
				sx={ {
					width: drawerWidth,
					flexShrink: 0,
					[`& .MuiDrawer-paper`]: {
						backgroundColor: bgcolor,
						color: color,
						width: drawerWidth,
						boxSizing: "border-box",
					},
				} }>
				<Toolbar />
				{ drawer }
			</Drawer>
		</Box>
	);
};

export default SideNav;
